<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><i>For my mother,</i></p>
<p class="center"><i>a remarkable woman who taught me many things, and</i></p>
<p class="center" style="margin-top:20px;"><i>For Richard,</i></p>
<p class="center"><i>who swam with me in the sacred cenote at Dzibilchaltún</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4dedication.vue?357909d8